/*
 * @Author: sunbingqing
 * @Date: 2020-02-13 18:00:52
 * @Last Modified by: sunbingqing
 * @Last Modified time: 2020-02-13 18:48:33
 */

<template>
  <div v-if="visible" class="share-cover" ref="shareCover" @click="closeShareCover">
    <img src="../../images/share/share_guide.png" alt />
  </div>
</template>

<script>
export default {
  name: "share-cover",
  props: {
    visible: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    closeShareCover() {
      this.$emit('close');
    }
  }
}
</script>

<style lang="less">
  .share-cover {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    img {
      display: block;
      width: 2.72rem;
      position: absolute;
      top: 0.6rem;
      right: 0.6rem;
    }
  }
</style>


// WEBPACK FOOTER //
// src/module/common/ShareCover.vue